import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const VerifiedIcon: React.FC<SvgProps> = ({ fill, stroke, ...props }) => {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path
        d="M8 0L9.76204 1.42398L12 1.0718L12.814 3.18602L14.9282 4L14.576 6.23796L16 8L14.576 9.76204L14.9282 12L12.814 12.814L12 14.9282L9.76204 14.576L8 16L6.23796 14.576L4 14.9282L3.18602 12.814L1.0718 12L1.42398 9.76204L0 8L1.42398 6.23796L1.0718 4L3.18602 3.18602L4 1.0718L6.23796 1.42398L8 0Z"
        fill={fill || '#00D6FF'}
      />
      <g clipPath="url(#clip0_4681_12507)">
        <path
          d="M10.3333 6L6.66667 9.66667L5 8"
          stroke={stroke || 'black'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4681_12507">
          <rect width="7.33333" height="7.66667" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default VerifiedIcon
